module.exports = __webpack_public_path__ + "static/media/smartMeterImg.3cd3efdd.jpg";